// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"_3XqxX-c8","spinAround":"_1I9kGBk_","circle":"ou10liX-"};